import { useState, useEffect } from 'react';
import CONSTANTS from "../constants/constants";

export default function useShareData() {
  const [ loading, setLoading ] = useState(true);
  const [ error, setError ] = useState(null);
  const [products, setProducts] = useState(null);

  useEffect(() => {
    setLoading(true);
    window.scroll(0,0);
    fetch(`${CONSTANTS.baseUrl}api/truestories/get-all-products`)
    .catch(err => setError(err))
    .then(res => res.json())
    .then(response => {
      const products = response.products
      .filter(product => product.product_type)
      .reduce((acc, product) => ({
        ...acc,
        [product.product_type]: [...(acc[product.product_type] || []), product],
      }), {})
      setProducts(products)
      setLoading(false)
    });
  }, [ ]);

  return [ loading, error, products ];
}
